import * as tslib_1 from "tslib";
import * as React from 'react';
import FloatingCompose from './FloatingCompose';
import composeStore from 'owa-mail-compose-store/lib/store/composeStore';
import { observer } from 'mobx-react';
var styles = require('./FloatingCompose.scss');
var FloatingComposeContainer = /** @class */ (function (_super) {
    tslib_1.__extends(FloatingComposeContainer, _super);
    function FloatingComposeContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FloatingComposeContainer.prototype.render = function () {
        return (React.createElement("div", { className: styles.floatingContainer }, composeStore.floatingViewStates
            .keys()
            .map(function (key) { return (React.createElement(FloatingCompose, { key: key, viewState: composeStore.floatingViewStates.get(key) })); })));
    };
    FloatingComposeContainer = tslib_1.__decorate([
        observer
    ], FloatingComposeContainer);
    return FloatingComposeContainer;
}(React.Component));
export default FloatingComposeContainer;
//# sourceMappingURL=FloatingComposeContainer.js.map